var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5C2.17157 1.5 1.5 2.1268 1.5 2.9C1.5 3.6732 2.17157 4.3 3 4.3C3.82843 4.3 4.5 3.6732 4.5 2.9C4.5 2.1268 3.82843 1.5 3 1.5ZM2.25 2.9C2.25 2.5134 2.58579 2.2 3 2.2C3.41421 2.2 3.75 2.5134 3.75 2.9C3.75 3.2866 3.41421 3.6 3 3.6C2.58579 3.6 2.25 3.2866 2.25 2.9ZM4.875 5L1.12499 5C0.503672 5 0 5.47012 0 6.04999C0 6.83125 0.344228 7.45718 0.909112 7.88036C1.46506 8.29684 2.21019 8.5 3 8.5C3.78981 8.5 4.53494 8.29684 5.09089 7.88036C5.65577 7.45718 6 6.83125 6 6.04999C6 5.4701 5.49632 5 4.875 5ZM1.12499 5.69999L4.875 5.69999C5.08211 5.69999 5.25 5.85669 5.25 6.04999C5.25 6.62183 5.0066 7.0459 4.62142 7.33446C4.22731 7.6297 3.65994 7.8 3 7.8C2.34006 7.8 1.77269 7.6297 1.37858 7.33446C0.993398 7.0459 0.75 6.62183 0.75 6.04999C0.75 5.8567 0.917903 5.69999 1.12499 5.69999Z",
    fill: "#747487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.685a4de66474980241096816fd2de50a.svg";
export { ForwardRef as ReactComponent };